import { OneEmptyState } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

const AssetDocumentsPage = () => {
  return (
    <div className="p-6">
      <OneEmptyState
        description={i18n.t('it_management.asset_details.documents.coming_soon_description')}
        emoji="📄"
        title={i18n.t('it_management.asset_details.documents.coming_soon_title')}
      />
    </div>
  )
}

export default AssetDocumentsPage
